import React from 'react';
import { StyleSheet, css } from 'aphrodite';

// MATERIAL UI 
import Hidden from '@material-ui/core/Hidden'

import RightMirror from '../../../assets/RightMirror.png'

export default class SkewBg extends React.Component{

  render(){
    return(
        <section>
            
        <div className={css(styles.mainContainer)}>
            <section className={css(styles.skewIntro)}>
            </section>
            <Hidden smDown> 
                <div className={css(styles.mirrorContainer)}>
                    <img className={css(styles.RightMirror)} src={RightMirror} alt=""/>
                </div>
            </Hidden>
        </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 250,
        width: '100vw',
        height: 1500,
        overflow: 'hidden',
        transform: 'skewY(-12deg)',
        transformOrigin: 0,
        background: 'linear-gradient(-69deg, #4D88FF, #457FDD)',
    },
    mirrorContainer: {
        position: 'absolute',
        top: 400,
        right: 0,
        height: 400,
        zIndex: -1
    },
    RightMirror : {
        height: 'inherit',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/PortfolioPart/SkewBg.js